module.exports = __webpack_public_path__ + "img/map_dark.e6b3d3d4.svg";